import type { UserPermissionsGroup } from '../models/UserPermissionsGroup'
import { UserPermissionsGroupDTO, mapUserPermissionsGroupToDTO, mapDTOToUserPermissionsGroup } from './DTOs/UserPermissionsGroupDTO'
import { CPBaseCRUDGateway } from '~/shared/gateways/CPBaseCRUDGateway'

type ListDTO = { profiles: UserPermissionsGroupDTO[] }

export class CPUserPermissionsGroupGateway extends CPBaseCRUDGateway<UserPermissionsGroupDTO, ListDTO, UserPermissionsGroup> {
  protected apiUrlDomain = 'profiles'
  protected dtoToModelMapper = mapDTOToUserPermissionsGroup
  // @ts-expect-error - mapper to request dto
  protected modelToDtoMapper = mapUserPermissionsGroupToDTO
  protected dtoSchema = UserPermissionsGroupDTO

  protected get listField (): 'profiles' {
    return 'profiles'
  }

  protected override get modelIdField (): keyof UserPermissionsGroup {
    return 'id'
  }
}
